import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
import ClientApplication from "../client_application.vue";

Vue.use(VueRouter);

const router_user = new VueRouter({
    routes: [
        {
            path: "/:readable_safe_url?",
            name: "ClientApplication",
            component: ClientApplication,
            children: [
                { path: "*", redirect: { name: "ClientApplication" } },
            ],
        },
    ],
});

export default router_user;
